/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForGraphionRiskScoreUpdate extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForGraphionRiskScoreUpdate");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForGraphionRiskScoreUpdate.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForGraphionRiskScoreUpdate>): BackgroundJobPayloadForGraphionRiskScoreUpdate {
        let obj = Object.assign(new BackgroundJobPayloadForGraphionRiskScoreUpdate(), model);
        BackgroundJobPayloadForGraphionRiskScoreUpdate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForGraphionRiskScoreUpdate>): BackgroundJobPayloadForGraphionRiskScoreUpdate {
        if (!model) return null;
        return BackgroundJobPayloadForGraphionRiskScoreUpdate.newInstance(<BackgroundJobPayloadForGraphionRiskScoreUpdate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForGraphionRiskScoreUpdate) {
        if (!obj) return;

        models.BackgroundJobPayloadForGraphionRiskScoreUpdate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForGraphionRiskScoreUpdate): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForGraphionRiskScoreUpdate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
